var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 19,
    fill: "#EB5757"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 21,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6874 13.8155L32.618 21.953C32.9321 22.2392 33.0358 22.68 32.8826 23.0762C32.7291 23.4723 32.3555 23.7282 31.9307 23.7282H30.5041V31.8814C30.5041 32.2047 30.242 32.4668 29.9187 32.4668H25.0239C24.7006 32.4668 24.4385 32.2047 24.4385 31.8814V26.931H21.5616V31.8814C21.5616 32.2047 21.2995 32.4668 20.9762 32.4668H16.0811C15.7579 32.4668 15.4958 32.2047 15.4958 31.8814V23.7282H14.0694C13.6446 23.7282 13.271 23.4723 13.1175 23.0762C12.9641 22.6801 13.0679 22.2392 13.3819 21.9531L22.3125 13.8155C22.7043 13.4583 23.2955 13.4583 23.6874 13.8155ZM26.4202 14.7161H30.3514C30.6747 14.7161 30.9367 14.9782 30.9367 15.3014V18.8229L26.4202 14.7161Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapHome);
export default __webpack_public_path__ + "static/media/map-home.218b8ec3a74865518dff03adc0fc34ac.svg";
export { ForwardRef as ReactComponent };